import { Coins, Hash, Percent, Ruler } from 'lucide-react';
import { CustomFieldDefinition, CustomFieldType } from '__types__';
import { FilterNumberConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createNumberFilterConfig(
  customFieldDef: CustomFieldDefinition
): FilterNumberConfig {
  let icon: React.ReactNode;

  switch (customFieldDef.data_type) {
    case CustomFieldType.PERCENTAGE:
      icon = <Percent />;
      break;
    case CustomFieldType.CURRENCY:
      icon = <Coins />;
      break;
    case CustomFieldType.MEASUREMENT:
    case CustomFieldType.MEASUREMENT_NEW:
      icon = <Ruler />;
      break;
    case CustomFieldType.NUMBER:
    default:
      icon = <Hash />;
      break;
  }

  return {
    label: customFieldDef.name,
    icon,
    type: 'number' as const,
    createDefaultValue: () => ({ operator: 'equal', value: 0 }),
    options: {}
  };
}
